




import {Component, Emit, Prop, Vue} from "vue-property-decorator";

@Component
export default class LoginButton extends Vue {
    @Emit()
    public login(){
    }

    public onClick(){
        this.login();
    }
}
